import { BaseService } from './BaseService';
import { onLogin, onLogout } from '@/services/ApolloDefaultClient';
import { FetchResult } from 'apollo-link';
import {
  LoginInformationInput,
  logoutUser
} from '@/types/graphql/schemaTypes';
import loginQuery from '@/graphql/mutations/Login.gql';
import logoutQuery from '@/graphql/mutations/Logout.gql';
import get from 'lodash/get';

class AuthenticationService extends BaseService {
  public async login(loginInformations: LoginInformationInput): Promise<any> {
    const result: boolean = await this.tryLogin(loginInformations)
      .then((response: any): boolean => {
        if (response.data.authenticateUser.loginToken) {
          onLogin(response.data.authenticateUser.loginToken);
        }
        return true;
      });
    return result;
  }

  public tryLogin(loginInformations: LoginInformationInput) {
    return this.client.mutate({
      mutation: loginQuery,
      variables: { loginInformations }
    });
  }

  public async logout(): Promise<FetchResult<logoutUser>> {
    const result: FetchResult<logoutUser> = await this.tryLogout();
    if (get(result, 'data.logoutUser')) {
      onLogout();
    }
    return result;
  }

  public async tryLogout(): Promise<FetchResult<logoutUser>> {
    return this.client.mutate({
      mutation: logoutQuery
    });
  }
}

export const authenticationService = new AuthenticationService();
